<div class="auth-page-wrapper pt-5" *ngIf = '!this.isLogin'>
    <!-- auth page bg -->
    <!-- auth page content -->
    <div class="auth-page-content">
        <div class="container">

            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6 col-xl-5">
                    <div class="card mt-4">
                    
                        <div class="card-body p-4"> 
                            <div class="text-center mt-2">
                                <h5 class="text-primary">Sign Up</h5>
                                <p class="text-muted"></p><br>
                                <span style="color:red;" *ngIf="errorStatus == 0">{{errorMessage}}</span>
                                <span style="color:green;" *ngIf="errorStatus == 1">{{errorMessage}}</span>
                            </div>
                            <div class="p-2 mt-4">
                                <form #myform = "ngForm" (ngSubmit)="onSubmit(myform)" ngNativeValidate>{{myform.data}}
                                    <div class="mb-3">
                                        <label for="usertype" class="form-label">Usertype *</label>
                                        <select name="usertype" class="form-control" required id="usertype" ngModel (change)="selectInput($event)">
                                            <option value="">Select Usertype</option>
                                            <option value="Admin">Admin</option>
                                            <option value="User">User</option>
                                        </select>
                                    </div>
                                    <div class="mb-3">
                                        <label for="firstname" class="form-label">Firstname *</label>
                                        <input type="text" class="form-control" required id="firstname" name="firstname" placeholder="Enter firstname" ngModel autocomplete="off">
                                    </div>
                                    <div class="mb-3">
                                        <label for="lastname" class="form-label">Lastname *</label>
                                        <input type="text" class="form-control" required id="lastname" name="lastname" placeholder="Enter lastname" ngModel autocomplete="off">
                                    </div>
                                    <div class="mb-3">
                                        <label for="username" class="form-label">Email-ID </label>
                                        <input type="email" class="form-control" id="email" name="email" placeholder="Enter Email-ID" ngModel autocomplete="off">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label" for="cusID">User ID *</label>
                                            <input type="text" class="form-control" required placeholder="Enter User ID" id="id" name="id" ngModel autocomplete="off">
                                    </div>
                                    
                                    <div class="mt-4">
                                     <input type="submit" class="btn btn-success w-100" name="login" value="Sign in"/>
                                    </div>
                                    
                                    <hr />
                                    <div class="mt-4">
                                        <a class="btn btn-primary w-100" (click)= "navlogin()">Login</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <!-- end card body -->
                    </div>
                    <!-- end card -->

                   

                </div>
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </div>
    <!-- end auth page content -->
</div>